import React, { useState } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import customersService from '../../services/ScaleoAdminApiServices/CustomersService';
import { CustomerCompanyName } from '../../types/customer';

interface CustomerAutoCompleteProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const CustomerAutoComplete: React.FC<CustomerAutoCompleteProps> = ({
  value,
  onChange,
  placeholder = 'Filtruj',
  className = 'p-column-filter',
}) => {
  const [suggestions, setSuggestions] = useState<CustomerCompanyName[]>([]);
  const [subValue, setSubValue] = useState<string | null>(null);

  const fetchData = async (searchQuery = ''): Promise<CustomerCompanyName[]> => {
    try {
      const { data } = await customersService.searchCustomerCompanyNames(searchQuery.trim(), 100);
      return data || [];
    } catch {
      return [];
    }
  };

  const completeMethod = async (e: any) => {
    const q = (e.query || '').trim();
    const list = await fetchData(q);
    setSuggestions(list);
  };

  const handleDropdownClick = async () => {
    const currentValue = getValue();
    const query = typeof currentValue === 'string' ? currentValue.trim() : '';
    const list = await fetchData(query);
    setSuggestions(list);
  };

  const defaultItemTemplate = (item: any) => (
    <div className="item">
      <div>{item.companyName}</div>
    </div>
  );

  const getValue = () => (subValue !== null ? subValue : value);

  const handleSelect = (e: any) => {
    setSubValue(null);
    onChange(e.value?.companyName || e.value);
  };

  const handleChange = (e: any) => {
    if (typeof e.value === 'string') {
      setSubValue(e.value);
    }
  };

  const handleBlur = () => {
    if (subValue !== null) {
      onChange(subValue);
      setSubValue(null);
    }
  };

  return (
    <AutoComplete
      value={getValue()}
      suggestions={suggestions}
      field="companyName"
      dropdown
      completeMethod={completeMethod}
      forceSelection={false}
      itemTemplate={defaultItemTemplate}
      placeholder={placeholder}
      className={className}
      onChange={handleChange}
      onSelect={handleSelect}
      onBlur={handleBlur}
      onDropdownClick={handleDropdownClick}
    />
  );
};

export default CustomerAutoComplete;
